export class Distance {
  constructor() {
    this.max_miles = 5;
  }
  public max_miles: number;
}
